module.exports = __webpack_public_path__ + "media/src/images/icons/pdf-392b51144c85876c093f92e684cf0dbb.svg";